<template>
  <div class="policy-wrap">
    <header class="section rules-header">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ data.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ data.desc }}
            </p>
          </div>
          <div class="column">
            <div class="image">
              <img v-if="data.image" alt="..." :src="data.image" />
            </div>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced">Party Book</h1>
            <p class="subtitle has-text-weight-medium">
              {{ data.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section rules">
      <div class="container">
        <h2 class="title has-text-centered mb-6">Party Book</h2>
        <div
          class="columns is-flex is-justify-content-center rules has-text-weight-medium has-text-grey-darker"
        >
          <div class="column is-8 is-10-mobile">
            <div v-html="data.content" class="play-html"></div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section covid1-9 has-background-info-light"
      v-if="config.shop_type == 0"
    >
      <div class="container">
        <div
          class="columns is-flex is-justify-content-center rules has-text-weight-medium has-text-black-ter"
        >
          <div class="column is-8 is-10-mobile">
            <h2 class="title has-text-centered mb-6">COVID-19 Response</h2>
            <p>We encourage all the adult guests to wear masks.</p>
            <p>
              Hand sanitizers are available in the playground. All guest should
              use hand sanitizer before entering the playground.
            </p>
            <p>
              Staff will clean and disinfect the play area after play times.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section contact" v-if="config.shop_type == 0">
      <div class="container">
        <div class="columns">
          <div class="column has-text-centered">
            <h4 class="title is-4">Have questions about the rules?</h4>
            <div
              @click="openDialog"
              class="button is-primary is-rounded has-text-weight-semibold mb-3"
            >
              Booking Online
            </div>
          </div>
        </div>
      </div>
    </section>
    <Book v-if="visible" :dialogVisible="visible" />
  </div>
</template>
<script>
import { partyInfo } from "@/server/api.js";
import store from "@/store";
import Book from "@/components/Book.vue";

export default {
  components: { Book },
  data() {
    return {
      visible: false,
      data: {},
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await partyInfo({
        });
        if (status == 0) {
          this.data = data;
        }
      } catch (error) {}
    },
    openDialog() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    }
  },
};
</script>
<style scoped>
.rules-header {
  background-color: #f5d784;
  margin: 0 auto;
  margin-top: 50px;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns.is-vcentered {
  align-items: center;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}
.title.is-1 {
  font-size: 3rem;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.title,
.subtitle {
  word-break: break-word;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}

.has-text-centered {
  text-align: center !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 1.25rem;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.has-text-white {
  color: #fff !important;
}
.fas,
.fa-solid {
  font-weight: 900;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.has-text-grey-darker {
  color: #363636 !important;
}
.is-justify-content-center {
  justify-content: center !important;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.is-flex {
  display: flex !important;
}
mark {
  background: linear-gradient(
    -100deg,
    hsla(48, 92%, 75%, 0.3),
    hsla(48, 92%, 75%, 0.7) 95%,
    hsla(48, 92%, 75%, 0.1)
  );
  border-radius: 1em 0;
  padding: 0.3rem;
}
li {
  margin-top: 0.5rem;
}
ol,
ul {
  margin-left: 2em;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.section {
  padding: 3rem 1.5rem;
}
.has-background-info-light {
  background-color: #eef3fc !important;
}
.has-text-black-ter {
  color: #242424 !important;
}
.mb-6 {
  margin-bottom: 3rem !important;
}
.title.is-4 {
  font-size: 1.5rem;
}
.button {
  background-color: #fff;
  border-color: #dbdbdb;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding: calc(0.5em - 1px) 1em;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select select,
.textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  position: relative;
  vertical-align: center;
}
.button.is-rounded {
  border-radius: 290486px;
  padding-left: calc(1em + 0.25em);
  padding-right: calc(1em + 0.25em);
}
.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.play-html >>> p {
  margin-bottom: 0.5rem !important;
}
.play-html >>> ol {
  margin-left: 2em;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.play-html >>> li {
  margin-top: 0.5rem;
}
.play-html >>> ::mark {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}
.play-html >>> mark {
  background: linear-gradient(
    -100deg,
    hsla(48, 92%, 75%, 0.3),
    hsla(48, 92%, 75%, 0.7) 95%,
    hsla(48, 92%, 75%, 0.1)
  );
  border-radius: 1em 0;
  padding: 0.3rem;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}

@media screen and (min-width: 769px), print {
  .is-hidden-tablet {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
  .column.is-8,
  .column.is-8-tablet {
    flex: none;
    width: 66.6666666667%;
  }
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/party/index.vue